/** Lightweight, deterministic field validation for the capture form (SPEC §7). */

export function isValidEmail(v: string): boolean {
  const s = v.trim();
  return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(s);
}

/** Accepts digits with optional leading + and common separators; needs >= 7 digits. */
export function isPlausiblePhone(v: string): boolean {
  const s = v.trim();
  if (!/^\+?[\d\s().-]+$/.test(s)) return false;
  return (s.match(/\d/g) ?? []).length >= 7;
}

export function fullName(first: string | null, last: string | null): string {
  return [first, last].filter(Boolean).join(' ').trim() || '(no name)';
}
